<template>
  <div class="yidi">
    <div class="ipbox">
      <titleCard title="Remote Hemodialysis"></titleCard>
      <div class="title-text">All the services including allochthonous dialysis, expert diagnosis and consultation, docking hospital, appointment bed, accompany and receive were provided to dialysis patients nationwide, so as to meet the needs of patients with blood permeation to travel, visiting relatives, traveling out of the country, and looking for patients, and to address all the 'concerns as they arise'.</div>
      <div class="PCbox">
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <img src="../../assets/image/innovatc/yidi1.webp">
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>01</h2>
            <h3>Strict screening cooperative medical institution</h3>
            <p>Cooperative medical institution will be checked by the Inspectors regularly. Cooperative medical institution which has already been established shall satisfy patient needs.</p>
          </div>
        </div>
        <div class="brief-box">
          <div class="box-txt  animate__animated wow animate__fadeInLeft">
            <h2>02</h2>
            <h3>Patient registration and Accompanying support services</h3>
            <p>Provide professionals with one-stop services. Such as finding the right hospital or dialysis center, registration, shuttle services, nursing assistant.</p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <img src="../../assets/image/innovatc/yidi2.webp">
          </div>
        </div>
        <div class="brief-box">
          <div class="box-img animate__animated wow animate__fadeInLeft">
            <img src="../../assets/image/innovatc/yidi3.webp">
          </div>
          <div class="box-txt animate__animated wow animate__fadeInRight">
            <h2>03</h2>
            <h3>Professional medical service network platform</h3>
            <p>The virtual + Real life integration mode makes the precise connection between patients and medical institutions, provides nephrotic patients with the whole range of medical services from chronic disease follow-up management services to dialysis.</p>
          </div>
        </div>
        <div class="brief-box">
          <div class="box-txt  animate__animated wow animate__fadeInLeft">
            <h2>04</h2>
            <h3>Medical association Two way patient transfer green channel </h3>
            <p>Establish a long-term "green channel" transfer rule with the local class III hospital located to meet different medical requirements of dialysis patients in different areas. Emergency patient transfer when complex vascular access or serious dialysis complications occurs. </p>
          </div>
          <div class="box-img animate__animated wow animate__fadeInRight">
            <img src="../../assets/image/innovatc/yidi4.webp">
          </div>
        </div>
      </div>
      <div class="Iosbox">
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/yidi1.webp">
          </div>
          <div class="txt">
            <div class="left">
              <h2>01</h2>
            </div>
            <div class="right">
              <h3>Strict screening cooperative medical institution</h3>
              <p>Cooperative medical institution will be checked by the Inspectors regularly. Cooperative medical institution which has already been established shall satisfy patient needs.</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/yidi2.webp">
          </div>
          <div class="txt">
            <div class="left">
              <h2>02</h2>
            </div>
            <div class="right">
              <h3>Patient registration and Accompanying support services</h3>
              <p>Provide professionals with one-stop services. Such as finding the right hospital or dialysis center, registration, shuttle services, nursing assistant.</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/yidi3.webp">
          </div>
          <div class="txt">
            <div class="left">
              <h2>03</h2>
            </div>
            <div class="right">
              <h3>Professional medical service network platform</h3>
              <p>The virtual + Real life integration mode makes the precise connection between patients and medical institutions, provides nephrotic patients with the whole range of medical services from chronic disease follow-up management services to dialysis.</p>
            </div>
          </div>
        </div>
        <div class="box animate__animated wow animate__fadeInUp">
          <div class="pic">
            <img src="../../assets/image/innovatc/yidi4.webp">
          </div>
          <div class="txt">
            <div class="left">
              <h2>04</h2>
            </div>
            <div class="right">
              <h3>Medical association Two way patient transfer green channel</h3>
              <p>Establish a long-term "green channel" transfer rule with the local class III hospital located to meet different medical requirements of dialysis patients in different areas. Emergency patient transfer when complex vascular access or serious dialysis complications occurs. </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footerCard name="Mr Li" phone="138-1097-5144"></footerCard>
  </div>
</template>

<script>
import footerCard from '../../components/footer-card.vue'
import titleCard from '../../components/title-card.vue'
export default {
  data() {
    return {

    }
  },
  components: {
    footerCard,
    titleCard
  },
  created() {

  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
.yidi {
  .ipbox {
    padding: 1.3684rem 0 1.5789rem 0;
    .title-text {
      color: #272b2d;
      font-size: 0.2526rem;
      text-align: center;
      padding: 0.5263rem 0 0;
      width: 80%;
      line-height: 0.5263rem;
      margin: 0 auto;
      @media screen and (max-width: 540px) {
        padding: 33px 0 20px 0;
        font-size: 13px;
        line-height: 25px;
        width: 90%;
      }
    }
    .PCbox {
      @media screen and (max-width: 540px) {
        display: none;
      }
      .brief-box {
        padding-top: 1.0526rem;
        display: flex;
        align-items: center;
        height: 5.8421rem;
        .box-img {
          width: 50%;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .boxstyle {
          padding-left: 2.3158rem !important;
        }
        .box-txt {
          width: 50%;
          box-sizing: border-box;
          padding:0 1.2789rem;
          h2 {
            margin: 0;
            color: #0ca6eb;
            font-size: 0.8421rem;
            font-weight: 700;
            position: relative;
          }
          h2::after {
            position: absolute;
            left: 0;
            bottom: 0;
            content: '';
            width: 0.2105rem;
            height: 0.0526rem;
            background-color: #0ca6eb;
          }
          h3 {
            margin: 0;
            padding: 0.3895rem 0 0.5053rem 0;
            color: #000000;
            font-size: 0.4211rem;
          }
          p {
            color: #333333;
            line-height: 0.4211rem;
            font-size: 0.2526rem;
          }
        }
      }
    }
    .Iosbox {
      display: none;
      margin-bottom: 45px;
      @media screen and (max-width: 540px) {
        display: block;
      }
      .box {
        padding: 0 15px;
        padding-top: 48px;
        .pic {
          width: 100%;
          height: 223px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .txt {
          padding-top: 15px;
          display: flex;
          .left {
            padding-right: 11px;
            h2 {
              position: relative;
              color: #0ca6eb;
              font-size: 30px;
              margin: 0;
            }
            h2::after {
              position: absolute;
              left: 9px;
              bottom: -2px;
              content: '';
              width: 18px;
              height: 3px;
              background-color: #0ca6eb;
            }
          }
          .right {
            flex-wrap: wrap;
            h3 {
              color: #000;
              font-size: 16px;
              margin: 0;
              padding-top: 8px;
              margin-bottom: 10px;
            }
            p {
              color: #333;
              font-size: 14px;
              padding-right: 15px;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}
</style>
